import { h } from "preact";
import { spinnerContainer, cssSpinner, firstDiv, secondDiv, thirdDiv } from "./Spinner.css";
var Spinner = function () {
    return (h("div", { "data-testid": "loading-spinner", className: spinnerContainer },
        h("div", { className: cssSpinner },
            h("div", { className: firstDiv }),
            h("div", { className: secondDiv }),
            h("div", { className: thirdDiv }))));
};
export default Spinner;
